import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebSocketService, WebSocketMessage } from '../../shared/websocket.service';

@Component({
  selector: 'app-drawing-stream',
  imports: [CommonModule],
  templateUrl: './drawing-stream.component.html',
  styleUrls: ['./drawing-stream.component.css']
})
export class DrawingStreamComponent implements OnInit, OnDestroy {
  public messages: any[] = [];
  private subscriptions: Subscription[] = [];

  constructor(private websocketService: WebSocketService) {}

  ngOnInit(): void {
    // Subscribe to drawing updates
    const drawingUpdateSub = this.websocketService.getDrawingUpdates().subscribe((message: WebSocketMessage) => {
      if (message.type === 'INSERT') {
        console.log('New drawing received:', message);
        this.messages.push({ type: 'new', data: message.data });
      } else if (message.type === 'MODIFY') {
        console.log('Drawing update received:', message);
        this.messages.push({ type: 'update', data: message.data });
      }
    });

    // Subscribe to all WebSocket messages for debugging
    const allMessagesSub = this.websocketService.messages$.subscribe((message: WebSocketMessage) => {
      console.log('WebSocket message in drawing-stream:', message);
    });

    this.subscriptions.push(drawingUpdateSub, allMessagesSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
